require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./seren-row-penthouses-qantas.json") })
        }
      }, "path---seren-row-penthouses-qantas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---seren-row-penthouses-qantas!./.cache/json/seren-row-penthouses-qantas.json
// module id = 892
// module chunks = 231608221292675